import type { Choice } from "@memorang/types/src/session/new-session";

export const getUserPrompt = (
	{
		stem,
		choices,
		explanation,
		topics,
		userResponse,
	}: {
		stem: string;
		choices: Choice[];
		explanation?: string;
		topics?: (string | undefined)[];
		userResponse?: string;
	},
	exam: string,
) => {
	const correctChoices = choices.find(({ isCorrect }) => isCorrect);
	const incorrectChoices = choices
		.filter(({ isCorrect }) => !isCorrect)
		.map(({ text }, index) => `Incorrect_Choice_${index + 1}: ${text}`)
		.join("\n");
	const topicsArray = topics
		? topics
				.map((topic, index) => `Topic Level ${index + 1}: ${topic}`)
				.join("\n")
		: [];
	const text = `\`\`\`json
    {
      Topic: [${exam},
      ${topicsArray}],
      Correct_Choice: ${correctChoices?.text},
      ${incorrectChoices},
      Stem: ${stem},
      explanation: ${explanation},
	  	${userResponse ? `User_Response: ${userResponse},` : ""}
    }
    \`\`\``;

	return text;
};
